//Custom components
import StatCard from '../../../UI/Card/StatCard';

const GrantFundsRemaining = ({ count }: { count: number | string }) => {
  return <StatCard title='Grant Funds Remaining' stat={`$ ${count}`} />;
};

export default GrantFundsRemaining;
